import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { LoginForm } from '../LoginForm'
import { Modal } from 'lib/ui'
import { InterceptBlurEvent } from 'lib/ui/components/Form/types'
import { getSlice } from 'lib/core/data/auth/login/selectors'
import { ModalContent } from './styled'

interface Props {
  handleCloseModal: () => void
  onLoginSuccess?: () => void
  isOpen: boolean
  afterTitle?: React.ReactNode
  emailInterceptBlur?: (e: InterceptBlurEvent<string>) => void
}

export const LoginModal = ({
  handleCloseModal,
  onLoginSuccess,
  isOpen,
  afterTitle,
  emailInterceptBlur
}: Props) => {
  const isFetching = useSelector(getSlice).isFetching

  return (
    <>
      <Modal
        handleCloseModal={isFetching ? undefined : handleCloseModal}
        isOpen={isOpen}
      >
        <ModalContent>
          <p>
            <FormattedMessage
              id='customer.account.login.title'
            />
          </p>
          {afterTitle}
          <LoginForm onLoginSuccess={onLoginSuccess} emailInterceptBlur={emailInterceptBlur} />
        </ModalContent>
      </Modal>
    </>
  )
}
